const translations = {
  en: {
    // Navigation
    nav: {
      home: "Home",
      businesses: "Partner Directory",
      membership: "Membership",
      login: "Login",
      register: "Sign Up",
      dashboard: "Dashboard",
      admin: "Admin",
      logout: "Logout"
    },
    // Landing Page
    landing: {
      hero_title: "Unlock",
      hero_subtitle: "Like a Local",
      hero_description: "The discount card and app for Costa del Sol, Tenerife and Mallorca. Save at 100+ restaurants, shops, and experiences in Marbella, Palma, Magaluf and more.",
      get_started: "Get Your Discount Card",
      view_partners: "View Partners",
      explore_partners: "Explore Partners",
      how_it_works: "How It Works",
      step1_title: "Get Your Discount Card",
      step1_desc: "Choose your pass — from just €14.99 for a week. Works across Costa del Sol and Tenerife.",
      step2_title: "Show & Save",
      step2_title_short: "Receive",
      step2_desc: "Get your digital discount card with a unique QR code instantly on your phone.",
      step3_title: "Enjoy More",
      step3_title_short: "Save",
      step3_desc: "Show your discount card at partner restaurants, shops and services and save up to 20%.",
      featured_partners: "Featured Partners",
      view_all: "View All Partners",
      ready_to_save: "Ready to Start Saving?",
      join_members: "Join hundreds of visitors discovering the best deals in Costa del Sol, Tenerife and Mallorca with our discount card app.",
      get_membership: "Get Your Membership",
      exclusive_membership: "Exclusive Membership",
      partners_count: "50+ Partners",
      discount_amount: "Up to 20% Off",
      coast_wide: "Coast-Wide",
      your_luxury: "Your Luxury",
      simplified: "Simplified",
      membership_options: "Membership Options",
      choose_your: "Choose Your",
      adventure: "Adventure",
      best_value: "Best Value",
      days_access: "days access",
      digital_card: "Digital Membership Card",
      discounts_range: "10-20% Discounts",
      all_partners: "All Partner Locations",
      select_plan: "Select Plan",
      our_partners: "Our Partners",
      curated: "Curated",
      experiences: "Experiences",
      dining_desc: "Fine restaurants & tapas bars",
      shopping_desc: "Boutiques & local artisans",
      services_desc: "Spas, tours & experiences",
      partners: "Partners",
      start_saving: "Start Saving",
      today: "Today",
      pricing: "Pricing",
      features: "Features"
    },
    // Auth
    auth: {
      welcome_back: "Welcome Back",
      sign_in_desc: "Sign in to access your membership",
      email: "Email",
      password: "Password",
      sign_in: "Sign In",
      forgot_password: "Forgot your password?",
      no_account: "Don't have an account?",
      create_one: "Create one",
      create_account: "Create Account",
      join_advanta: "Join Advanta Plus and start saving",
      first_name: "First Name",
      last_name: "Last Name",
      confirm_password: "Confirm Password",
      accept_privacy: "I accept the Privacy Policy and consent to the processing of my personal data",
      have_account: "Already have an account?",
      sign_in_link: "Sign in"
    },
    // Dashboard
    dashboard: {
      your_membership: "Your Membership",
      manage_membership: "Manage your Advanta Plus membership",
      member_since: "Member Since",
      valid_until: "Valid Until",
      show_qr: "Show QR Code",
      add_to_wallet: "Add to Wallet",
      browse_partners: "Browse Partners",
      upgrade_plan: "Upgrade Plan",
      no_membership: "No Active Membership",
      get_card_desc: "Get your Advanta Plus card and start enjoying exclusive discounts at partner locations across Costa del Sol.",
      get_card: "Get Your Card",
      welcome: "Welcome",
      digital_membership: "Digital Membership",
      active: "Active",
      expired: "Expired",
      member: "Member",
      membership_expired: "Membership Expired",
      renew_desc: "Your membership has expired. Renew to continue saving.",
      renew: "Renew Membership",
      quick_actions: "Quick Actions",
      upgrade: "Upgrade",
      account: "Account"
    },
    // Business Directory
    directory: {
      title: "Partner Directory",
      explore: "Explore",
      costa_del_sol: "Costa del Sol",
      discover_desc: "Discover exclusive discounts at our curated partner locations",
      search: "Search partners...",
      all: "All",
      dining: "Dining",
      shopping: "Shopping",
      services: "Services",
      all_locations: "All Locations",
      no_partners: "No partners found",
      discount: "discount",
      map_view: "Map View"
    },
    // Common
    common: {
      loading: "Loading...",
      save: "Save",
      cancel: "Cancel",
      submit: "Submit",
      back: "Back",
      next: "Next",
      close: "Close",
      download: "Download",
      view_details: "View Details"
    },
    // Footer
    footer: {
      rights: "All rights reserved",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      tagline: "Exclusive member discounts across Costa del Sol",
      for_members: "For Members",
      directory: "Directory",
      for_business: "For Business",
      become_partner: "Become a Partner",
      qr_scanner: "QR Scanner",
      affiliates: "Affiliates",
      become_affiliate: "Become an Affiliate",
      earn_commission: "Earn 20% commission"
    }
  },
  es: {
    nav: {
      home: "Inicio",
      businesses: "Directorio de Socios",
      membership: "Membresía",
      login: "Iniciar Sesión",
      register: "Registrarse",
      dashboard: "Panel",
      admin: "Admin",
      logout: "Cerrar Sesión"
    },
    landing: {
      hero_title: "Descubre",
      hero_subtitle: "Como un Local",
      hero_description: "La tarjeta de descuento y app para Costa del Sol, Tenerife y Mallorca. Ahorra en más de 100 restaurantes, tiendas y experiencias en Marbella, Palma, Magaluf y más.",
      get_started: "Obtén Tu Tarjeta de Descuento",
      view_partners: "Ver Socios",
      explore_partners: "Explorar Socios",
      how_it_works: "Cómo Funciona",
      step1_title: "Obtén Tu Tarjeta de Descuento",
      step1_desc: "Elige tu pase — desde solo 14,99€ por una semana. Funciona en Costa del Sol, Tenerife y Mallorca.",
      step2_title: "Muestra y Ahorra",
      step2_title_short: "Recibe",
      step2_desc: "Recibe tu tarjeta de descuento digital con un código QR único al instante en tu móvil.",
      step3_title: "Disfruta Más",
      step3_title_short: "Ahorra",
      step3_desc: "Muestra tu tarjeta de descuento en restaurantes, tiendas y servicios asociados y ahorra hasta un 20%.",
      featured_partners: "Socios Destacados",
      view_all: "Ver Todos los Socios",
      ready_to_save: "¿Listo para Empezar a Ahorrar?",
      join_members: "Únete a cientos de visitantes descubriendo las mejores ofertas en Costa del Sol, Tenerife y Mallorca con nuestra tarjeta de descuento.",
      get_membership: "Obtén Tu Membresía",
      exclusive_membership: "Membresía Exclusiva",
      partners_count: "50+ Socios",
      discount_amount: "Hasta 20% de Descuento",
      coast_wide: "Toda la Costa",
      your_luxury: "Tu Lujo",
      simplified: "Simplificado",
      membership_options: "Opciones de Membresía",
      choose_your: "Elige Tu",
      adventure: "Aventura",
      best_value: "Mejor Valor",
      days_access: "días de acceso",
      digital_card: "Tarjeta de Membresía Digital",
      discounts_range: "10-20% de Descuento",
      all_partners: "Todas las Ubicaciones",
      select_plan: "Seleccionar Plan",
      our_partners: "Nuestros Socios",
      curated: "Experiencias",
      experiences: "Seleccionadas",
      dining_desc: "Restaurantes finos y bares de tapas",
      shopping_desc: "Boutiques y artesanos locales",
      services_desc: "Spas, tours y experiencias",
      partners: "Socios",
      start_saving: "Empieza a Ahorrar",
      today: "Hoy",
      pricing: "Precios",
      features: "Características"
    },
    auth: {
      welcome_back: "Bienvenido",
      sign_in_desc: "Inicia sesión para acceder a tu membresía",
      email: "Correo Electrónico",
      password: "Contraseña",
      sign_in: "Iniciar Sesión",
      forgot_password: "¿Olvidaste tu contraseña?",
      no_account: "¿No tienes cuenta?",
      create_one: "Crear una",
      create_account: "Crear Cuenta",
      join_advanta: "Únete a Advanta Plus y empieza a ahorrar",
      first_name: "Nombre",
      last_name: "Apellido",
      confirm_password: "Confirmar Contraseña",
      accept_privacy: "Acepto la Política de Privacidad y el procesamiento de mis datos personales",
      have_account: "¿Ya tienes cuenta?",
      sign_in_link: "Iniciar sesión"
    },
    dashboard: {
      your_membership: "Tu Membresía",
      manage_membership: "Gestiona tu membresía Advanta Plus",
      member_since: "Miembro Desde",
      valid_until: "Válido Hasta",
      show_qr: "Mostrar Código QR",
      add_to_wallet: "Añadir a Cartera",
      browse_partners: "Ver Socios",
      upgrade_plan: "Mejorar Plan",
      no_membership: "Sin Membresía Activa",
      get_card_desc: "Obtén tu tarjeta Advanta Plus y empieza a disfrutar descuentos exclusivos en ubicaciones asociadas en Costa del Sol.",
      get_card: "Obtén Tu Tarjeta",
      welcome: "Bienvenido",
      digital_membership: "Membresía Digital",
      active: "Activa",
      expired: "Expirada",
      member: "Miembro",
      membership_expired: "Membresía Expirada",
      renew_desc: "Tu membresía ha expirado. Renueva para seguir ahorrando.",
      renew: "Renovar Membresía",
      quick_actions: "Acciones Rápidas",
      upgrade: "Mejorar",
      account: "Cuenta"
    },
    directory: {
      title: "Directorio de Socios",
      explore: "Explora",
      costa_del_sol: "Costa del Sol",
      discover_desc: "Descubre descuentos exclusivos en nuestras ubicaciones asociadas",
      search: "Buscar socios...",
      all: "Todos",
      dining: "Gastronomía",
      shopping: "Compras",
      services: "Servicios",
      all_locations: "Todas las Ubicaciones",
      no_partners: "No se encontraron socios",
      discount: "descuento",
      map_view: "Vista de Mapa"
    },
    common: {
      loading: "Cargando...",
      save: "Guardar",
      cancel: "Cancelar",
      submit: "Enviar",
      back: "Atrás",
      next: "Siguiente",
      close: "Cerrar",
      download: "Descargar",
      view_details: "Ver Detalles"
    },
    footer: {
      rights: "Todos los derechos reservados",
      privacy: "Política de Privacidad",
      terms: "Términos de Servicio",
      tagline: "Descuentos exclusivos para miembros en Costa del Sol",
      for_members: "Para Miembros",
      directory: "Directorio",
      for_business: "Para Negocios",
      become_partner: "Conviértete en Socio",
      qr_scanner: "Escáner QR",
      affiliates: "Afiliados",
      become_affiliate: "Conviértete en Afiliado",
      earn_commission: "Gana 20% de comisión"
    }
  },
  de: {
    nav: {
      home: "Startseite",
      businesses: "Partnerverzeichnis",
      membership: "Mitgliedschaft",
      login: "Anmelden",
      register: "Registrieren",
      dashboard: "Dashboard",
      admin: "Admin",
      logout: "Abmelden"
    },
    landing: {
      hero_title: "Entdecke",
      hero_subtitle: "Wie ein Einheimischer",
      hero_description: "Dein Pass zu exklusiven Rabatten in den besten Restaurants, Geschäften und Erlebnissen der Küste.",
      get_started: "Hol dir deine Karte",
      view_partners: "Partner ansehen",
      explore_partners: "Partner entdecken",
      how_it_works: "So funktioniert's",
      step1_title: "Hol dir deine Karte",
      step1_desc: "Wähle deine Mitgliedschaftsdauer und tätige eine sichere Einmalzahlung.",
      step2_title: "Zeigen & Sparen",
      step2_title_short: "Erhalten",
      step2_desc: "Erhalte deine digitale Mitgliedskarte mit einzigartigem QR-Code sofort.",
      step3_title: "Mehr genießen",
      step3_title_short: "Sparen",
      step3_desc: "Zeige deine Karte bei Partnerstandorten und genieße exklusive Rabatte.",
      featured_partners: "Ausgewählte Partner",
      view_all: "Alle Partner ansehen",
      ready_to_save: "Bereit zum Sparen?",
      join_members: "Schließe dich Hunderten von Reisenden an, die das Beste der Costa del Sol mit exklusiven lokalen Rabatten entdecken.",
      get_membership: "Mitgliedschaft erhalten",
      exclusive_membership: "Exklusive Mitgliedschaft",
      partners_count: "50+ Partner",
      discount_amount: "Bis zu 20% Rabatt",
      coast_wide: "Küstenweit",
      your_luxury: "Dein Luxus",
      simplified: "Vereinfacht",
      membership_options: "Mitgliedschaftsoptionen",
      choose_your: "Wähle dein",
      adventure: "Abenteuer",
      best_value: "Bester Wert",
      days_access: "Tage Zugang",
      digital_card: "Digitale Mitgliedskarte",
      discounts_range: "10-20% Rabatte",
      all_partners: "Alle Partnerstandorte",
      select_plan: "Plan wählen",
      our_partners: "Unsere Partner",
      curated: "Kuratierte",
      experiences: "Erlebnisse",
      dining_desc: "Feine Restaurants & Tapas-Bars",
      shopping_desc: "Boutiquen & lokale Kunsthandwerker",
      services_desc: "Spas, Touren & Erlebnisse",
      partners: "Partner",
      start_saving: "Jetzt Sparen",
      today: "Beginnen",
      pricing: "Preise",
      features: "Funktionen"
    },
    auth: {
      welcome_back: "Willkommen zurück",
      sign_in_desc: "Melde dich an, um auf deine Mitgliedschaft zuzugreifen",
      email: "E-Mail",
      password: "Passwort",
      sign_in: "Anmelden",
      forgot_password: "Passwort vergessen?",
      no_account: "Noch kein Konto?",
      create_one: "Erstelle eins",
      create_account: "Konto erstellen",
      join_advanta: "Tritt Advanta Plus bei und spare",
      first_name: "Vorname",
      last_name: "Nachname",
      confirm_password: "Passwort bestätigen",
      accept_privacy: "Ich akzeptiere die Datenschutzrichtlinie und die Verarbeitung meiner persönlichen Daten",
      have_account: "Bereits ein Konto?",
      sign_in_link: "Anmelden"
    },
    dashboard: {
      your_membership: "Deine Mitgliedschaft",
      manage_membership: "Verwalte deine Advanta Plus Mitgliedschaft",
      member_since: "Mitglied seit",
      valid_until: "Gültig bis",
      show_qr: "QR-Code anzeigen",
      add_to_wallet: "Zur Wallet hinzufügen",
      browse_partners: "Partner durchsuchen",
      upgrade_plan: "Plan upgraden",
      no_membership: "Keine aktive Mitgliedschaft",
      get_card_desc: "Hol dir deine Advanta Plus Karte und genieße exklusive Rabatte bei Partnerstandorten an der Costa del Sol.",
      get_card: "Karte erhalten",
      welcome: "Willkommen",
      digital_membership: "Digitale Mitgliedschaft",
      active: "Aktiv",
      expired: "Abgelaufen",
      member: "Mitglied",
      membership_expired: "Mitgliedschaft Abgelaufen",
      renew_desc: "Deine Mitgliedschaft ist abgelaufen. Verlängere sie, um weiter zu sparen.",
      renew: "Mitgliedschaft Verlängern",
      quick_actions: "Schnellaktionen",
      upgrade: "Upgraden",
      account: "Konto"
    },
    directory: {
      title: "Partnerverzeichnis",
      explore: "Entdecke",
      costa_del_sol: "Costa del Sol",
      discover_desc: "Entdecke exklusive Rabatte bei unseren kuratierten Partnerstandorten",
      search: "Partner suchen...",
      all: "Alle",
      dining: "Gastronomie",
      shopping: "Shopping",
      services: "Services",
      all_locations: "Alle Standorte",
      no_partners: "Keine Partner gefunden",
      discount: "Rabatt",
      map_view: "Kartenansicht"
    },
    common: {
      loading: "Lädt...",
      save: "Speichern",
      cancel: "Abbrechen",
      submit: "Absenden",
      back: "Zurück",
      next: "Weiter",
      close: "Schließen",
      download: "Herunterladen",
      view_details: "Details ansehen"
    },
    footer: {
      rights: "Alle Rechte vorbehalten",
      privacy: "Datenschutz",
      terms: "Nutzungsbedingungen",
      tagline: "Exklusive Mitgliederrabatte an der Costa del Sol",
      for_members: "Für Mitglieder",
      directory: "Verzeichnis",
      for_business: "Für Unternehmen",
      become_partner: "Partner werden",
      qr_scanner: "QR-Scanner",
      affiliates: "Affiliates",
      become_affiliate: "Affiliate werden",
      earn_commission: "20% Provision verdienen"
    }
  },
  fr: {
    nav: {
      home: "Accueil",
      businesses: "Répertoire Partenaires",
      membership: "Adhésion",
      login: "Connexion",
      register: "S'inscrire",
      dashboard: "Tableau de bord",
      admin: "Admin",
      logout: "Déconnexion"
    },
    landing: {
      hero_title: "Découvrez",
      hero_subtitle: "Comme un Local",
      hero_description: "Votre passeport vers des réductions exclusives dans les meilleurs restaurants, boutiques et expériences de la côte.",
      get_started: "Obtenez Votre Carte",
      view_partners: "Voir les Partenaires",
      explore_partners: "Explorer les Partenaires",
      how_it_works: "Comment ça marche",
      step1_title: "Obtenez Votre Carte",
      step1_desc: "Choisissez la durée de votre adhésion et effectuez un paiement unique sécurisé.",
      step2_title: "Montrez & Économisez",
      step2_title_short: "Recevez",
      step2_desc: "Recevez votre carte d'adhésion numérique avec un QR code unique instantanément.",
      step3_title: "Profitez Plus",
      step3_title_short: "Économisez",
      step3_desc: "Montrez votre carte chez les partenaires et profitez de réductions exclusives.",
      featured_partners: "Partenaires en Vedette",
      view_all: "Voir Tous les Partenaires",
      ready_to_save: "Prêt à Économiser?",
      join_members: "Rejoignez des centaines de voyageurs découvrant le meilleur de la Costa del Sol avec des réductions locales exclusives.",
      get_membership: "Obtenez Votre Adhésion",
      exclusive_membership: "Adhésion Exclusive",
      partners_count: "50+ Partenaires",
      discount_amount: "Jusqu'à 20% de Réduction",
      coast_wide: "Toute la Côte",
      your_luxury: "Votre Luxe",
      simplified: "Simplifié",
      membership_options: "Options d'Adhésion",
      choose_your: "Choisissez Votre",
      adventure: "Aventure",
      best_value: "Meilleur Rapport",
      days_access: "jours d'accès",
      digital_card: "Carte d'Adhésion Numérique",
      discounts_range: "10-20% de Réductions",
      all_partners: "Tous les Emplacements",
      select_plan: "Sélectionner le Plan",
      our_partners: "Nos Partenaires",
      curated: "Expériences",
      experiences: "Sélectionnées",
      dining_desc: "Restaurants gastronomiques & bars à tapas",
      shopping_desc: "Boutiques & artisans locaux",
      services_desc: "Spas, visites & expériences",
      partners: "Partenaires",
      start_saving: "Commencez à Économiser",
      today: "Aujourd'hui",
      pricing: "Tarifs",
      features: "Fonctionnalités"
    },
    auth: {
      welcome_back: "Bon Retour",
      sign_in_desc: "Connectez-vous pour accéder à votre adhésion",
      email: "E-mail",
      password: "Mot de passe",
      sign_in: "Se Connecter",
      forgot_password: "Mot de passe oublié?",
      no_account: "Pas de compte?",
      create_one: "Créez-en un",
      create_account: "Créer un Compte",
      join_advanta: "Rejoignez Advanta Plus et économisez",
      first_name: "Prénom",
      last_name: "Nom",
      confirm_password: "Confirmer le mot de passe",
      accept_privacy: "J'accepte la Politique de Confidentialité et le traitement de mes données personnelles",
      have_account: "Déjà un compte?",
      sign_in_link: "Se connecter"
    },
    dashboard: {
      your_membership: "Votre Adhésion",
      manage_membership: "Gérez votre adhésion Advanta Plus",
      member_since: "Membre Depuis",
      valid_until: "Valide Jusqu'au",
      show_qr: "Afficher le QR Code",
      add_to_wallet: "Ajouter au Portefeuille",
      browse_partners: "Parcourir les Partenaires",
      upgrade_plan: "Améliorer le Plan",
      no_membership: "Pas d'Adhésion Active",
      get_card_desc: "Obtenez votre carte Advanta Plus et profitez de réductions exclusives chez les partenaires de la Costa del Sol.",
      get_card: "Obtenez Votre Carte",
      welcome: "Bienvenue",
      digital_membership: "Adhésion Numérique",
      active: "Active",
      expired: "Expirée",
      member: "Membre",
      membership_expired: "Adhésion Expirée",
      renew_desc: "Votre adhésion a expiré. Renouvelez-la pour continuer à économiser.",
      renew: "Renouveler l'Adhésion",
      quick_actions: "Actions Rapides",
      upgrade: "Améliorer",
      account: "Compte"
    },
    directory: {
      title: "Répertoire Partenaires",
      explore: "Explorez",
      costa_del_sol: "Costa del Sol",
      discover_desc: "Découvrez des réductions exclusives chez nos partenaires sélectionnés",
      search: "Rechercher des partenaires...",
      all: "Tous",
      dining: "Restauration",
      shopping: "Shopping",
      services: "Services",
      all_locations: "Tous les Emplacements",
      no_partners: "Aucun partenaire trouvé",
      discount: "réduction",
      map_view: "Vue Carte"
    },
    common: {
      loading: "Chargement...",
      save: "Enregistrer",
      cancel: "Annuler",
      submit: "Soumettre",
      back: "Retour",
      next: "Suivant",
      close: "Fermer",
      download: "Télécharger",
      view_details: "Voir les Détails"
    },
    footer: {
      rights: "Tous droits réservés",
      privacy: "Politique de Confidentialité",
      terms: "Conditions d'Utilisation",
      tagline: "Réductions exclusives pour membres sur la Costa del Sol",
      for_members: "Pour les Membres",
      directory: "Répertoire",
      for_business: "Pour les Entreprises",
      become_partner: "Devenir Partenaire",
      qr_scanner: "Scanner QR",
      affiliates: "Affiliés",
      become_affiliate: "Devenir Affilié",
      earn_commission: "Gagnez 20% de commission"
    }
  },
  ru: {
    nav: {
      home: "Главная",
      businesses: "Каталог Партнеров",
      membership: "Членство",
      login: "Вход",
      register: "Регистрация",
      dashboard: "Панель",
      admin: "Админ",
      logout: "Выход"
    },
    landing: {
      hero_title: "Откройте",
      hero_subtitle: "Как Местный",
      hero_description: "Ваш пропуск к эксклюзивным скидкам в лучших ресторанах, магазинах и развлечениях побережья.",
      get_started: "Получить Карту",
      view_partners: "Смотреть Партнеров",
      explore_partners: "Исследовать Партнеров",
      how_it_works: "Как Это Работает",
      step1_title: "Получите Карту",
      step1_desc: "Выберите срок членства и совершите безопасный разовый платеж.",
      step2_title: "Покажите и Сэкономьте",
      step2_title_short: "Получите",
      step2_desc: "Получите цифровую карту членства с уникальным QR-кодом мгновенно.",
      step3_title: "Наслаждайтесь Больше",
      step3_title_short: "Экономьте",
      step3_desc: "Покажите карту у партнеров и наслаждайтесь эксклюзивными скидками.",
      featured_partners: "Избранные Партнеры",
      view_all: "Все Партнеры",
      ready_to_save: "Готовы Экономить?",
      join_members: "Присоединяйтесь к сотням путешественников, открывающих лучшее на Коста-дель-Соль с эксклюзивными местными скидками.",
      get_membership: "Получить Членство",
      exclusive_membership: "Эксклюзивное Членство",
      partners_count: "50+ Партнеров",
      discount_amount: "До 20% Скидки",
      coast_wide: "Всё Побережье",
      your_luxury: "Ваша Роскошь",
      simplified: "Упрощённая",
      membership_options: "Варианты Членства",
      choose_your: "Выберите Своё",
      adventure: "Приключение",
      best_value: "Лучшее Предложение",
      days_access: "дней доступа",
      digital_card: "Цифровая Карта Членства",
      discounts_range: "10-20% Скидки",
      all_partners: "Все Локации Партнеров",
      select_plan: "Выбрать План",
      our_partners: "Наши Партнеры",
      curated: "Избранные",
      experiences: "Впечатления",
      dining_desc: "Изысканные рестораны и тапас-бары",
      shopping_desc: "Бутики и местные ремесленники",
      services_desc: "Спа, туры и впечатления",
      partners: "Партнеров",
      start_saving: "Начните Экономить",
      today: "Сегодня",
      pricing: "Цены",
      features: "Возможности"
    },
    auth: {
      welcome_back: "С Возвращением",
      sign_in_desc: "Войдите для доступа к членству",
      email: "Электронная почта",
      password: "Пароль",
      sign_in: "Войти",
      forgot_password: "Забыли пароль?",
      no_account: "Нет аккаунта?",
      create_one: "Создать",
      create_account: "Создать Аккаунт",
      join_advanta: "Присоединяйтесь к Advanta Plus и экономьте",
      first_name: "Имя",
      last_name: "Фамилия",
      confirm_password: "Подтвердите пароль",
      accept_privacy: "Я принимаю Политику Конфиденциальности и обработку моих персональных данных",
      have_account: "Уже есть аккаунт?",
      sign_in_link: "Войти"
    },
    dashboard: {
      your_membership: "Ваше Членство",
      manage_membership: "Управляйте членством Advanta Plus",
      member_since: "Участник С",
      valid_until: "Действует До",
      show_qr: "Показать QR Код",
      add_to_wallet: "Добавить в Кошелек",
      browse_partners: "Просмотр Партнеров",
      upgrade_plan: "Улучшить План",
      no_membership: "Нет Активного Членства",
      get_card_desc: "Получите карту Advanta Plus и наслаждайтесь эксклюзивными скидками у партнеров на Коста-дель-Соль.",
      get_card: "Получить Карту",
      welcome: "Добро пожаловать",
      digital_membership: "Цифровое Членство",
      active: "Активно",
      expired: "Истекло",
      member: "Участник",
      membership_expired: "Членство Истекло",
      renew_desc: "Ваше членство истекло. Продлите его, чтобы продолжить экономить.",
      renew: "Продлить Членство",
      quick_actions: "Быстрые Действия",
      upgrade: "Улучшить",
      account: "Аккаунт"
    },
    directory: {
      title: "Каталог Партнеров",
      explore: "Исследуйте",
      costa_del_sol: "Коста-дель-Соль",
      discover_desc: "Откройте эксклюзивные скидки у наших партнеров",
      search: "Поиск партнеров...",
      all: "Все",
      dining: "Рестораны",
      shopping: "Покупки",
      services: "Услуги",
      all_locations: "Все Локации",
      no_partners: "Партнеры не найдены",
      discount: "скидка",
      map_view: "Вид Карты"
    },
    common: {
      loading: "Загрузка...",
      save: "Сохранить",
      cancel: "Отмена",
      submit: "Отправить",
      back: "Назад",
      next: "Далее",
      close: "Закрыть",
      download: "Скачать",
      view_details: "Подробнее"
    },
    footer: {
      rights: "Все права защищены",
      privacy: "Политика Конфиденциальности",
      terms: "Условия Использования",
      tagline: "Эксклюзивные скидки для участников на Коста-дель-Соль",
      for_members: "Для Участников",
      directory: "Каталог",
      for_business: "Для Бизнеса",
      become_partner: "Стать Партнером",
      qr_scanner: "QR Сканер",
      affiliates: "Партнёрская Программа",
      become_affiliate: "Стать Партнёром",
      earn_commission: "Заработайте 20% комиссии"
    }
  },
  nl: {
    nav: {
      home: "Home",
      businesses: "Partnergids",
      membership: "Lidmaatschap",
      login: "Inloggen",
      register: "Registreren",
      dashboard: "Dashboard",
      admin: "Admin",
      logout: "Uitloggen"
    },
    landing: {
      hero_title: "Ontdek",
      hero_subtitle: "Als een Local",
      hero_description: "Jouw paspoort naar exclusieve kortingen bij de beste restaurants, winkels en ervaringen aan de kust.",
      get_started: "Haal Je Kaart",
      view_partners: "Bekijk Partners",
      explore_partners: "Ontdek Partners",
      how_it_works: "Hoe Het Werkt",
      step1_title: "Haal Je Kaart",
      step1_desc: "Kies je lidmaatschapsduur en voltooi een veilige eenmalige betaling.",
      step2_title: "Toon & Bespaar",
      step2_title_short: "Ontvang",
      step2_desc: "Ontvang direct je digitale lidmaatschapskaart met unieke QR-code.",
      step3_title: "Geniet Meer",
      step3_title_short: "Bespaar",
      step3_desc: "Toon je kaart bij partnerlocaties en geniet van exclusieve kortingen.",
      featured_partners: "Uitgelichte Partners",
      view_all: "Alle Partners Bekijken",
      ready_to_save: "Klaar om te Besparen?",
      join_members: "Sluit je aan bij honderden reizigers die het beste van de Costa del Sol ontdekken met exclusieve lokale kortingen.",
      get_membership: "Haal Je Lidmaatschap",
      exclusive_membership: "Exclusief Lidmaatschap",
      partners_count: "50+ Partners",
      discount_amount: "Tot 20% Korting",
      coast_wide: "Hele Kust",
      your_luxury: "Jouw Luxe",
      simplified: "Vereenvoudigd",
      membership_options: "Lidmaatschapsopties",
      choose_your: "Kies Je",
      adventure: "Avontuur",
      best_value: "Beste Waarde",
      days_access: "dagen toegang",
      digital_card: "Digitale Lidmaatschapskaart",
      discounts_range: "10-20% Kortingen",
      all_partners: "Alle Partnerlocaties",
      select_plan: "Plan Kiezen",
      our_partners: "Onze Partners",
      curated: "Geselecteerde",
      experiences: "Ervaringen",
      dining_desc: "Fijne restaurants & tapasbars",
      shopping_desc: "Boetieks & lokale ambachtslieden",
      services_desc: "Spa's, tours & ervaringen",
      partners: "Partners",
      start_saving: "Begin met Besparen",
      today: "Vandaag",
      pricing: "Prijzen",
      features: "Functies"
    },
    auth: {
      welcome_back: "Welkom Terug",
      sign_in_desc: "Log in om toegang te krijgen tot je lidmaatschap",
      email: "E-mail",
      password: "Wachtwoord",
      sign_in: "Inloggen",
      forgot_password: "Wachtwoord vergeten?",
      no_account: "Geen account?",
      create_one: "Maak er een",
      create_account: "Account Aanmaken",
      join_advanta: "Word lid van Advanta Plus en bespaar",
      first_name: "Voornaam",
      last_name: "Achternaam",
      confirm_password: "Bevestig wachtwoord",
      accept_privacy: "Ik accepteer het Privacybeleid en de verwerking van mijn persoonlijke gegevens",
      have_account: "Al een account?",
      sign_in_link: "Inloggen"
    },
    dashboard: {
      your_membership: "Je Lidmaatschap",
      manage_membership: "Beheer je Advanta Plus lidmaatschap",
      member_since: "Lid Sinds",
      valid_until: "Geldig Tot",
      show_qr: "QR Code Tonen",
      add_to_wallet: "Toevoegen aan Wallet",
      browse_partners: "Partners Bekijken",
      upgrade_plan: "Plan Upgraden",
      no_membership: "Geen Actief Lidmaatschap",
      get_card_desc: "Haal je Advanta Plus kaart en geniet van exclusieve kortingen bij partnerlocaties langs de Costa del Sol.",
      get_card: "Haal Je Kaart",
      welcome: "Welkom",
      digital_membership: "Digitaal Lidmaatschap",
      active: "Actief",
      expired: "Verlopen",
      member: "Lid",
      membership_expired: "Lidmaatschap Verlopen",
      renew_desc: "Je lidmaatschap is verlopen. Verleng om te blijven besparen.",
      renew: "Lidmaatschap Verlengen",
      quick_actions: "Snelle Acties",
      upgrade: "Upgraden",
      account: "Account"
    },
    directory: {
      title: "Partnergids",
      explore: "Ontdek",
      costa_del_sol: "Costa del Sol",
      discover_desc: "Ontdek exclusieve kortingen bij onze geselecteerde partnerlocaties",
      search: "Partners zoeken...",
      all: "Alle",
      dining: "Eten",
      shopping: "Winkelen",
      services: "Diensten",
      all_locations: "Alle Locaties",
      no_partners: "Geen partners gevonden",
      discount: "korting",
      map_view: "Kaartweergave"
    },
    common: {
      loading: "Laden...",
      save: "Opslaan",
      cancel: "Annuleren",
      submit: "Verzenden",
      back: "Terug",
      next: "Volgende",
      close: "Sluiten",
      download: "Downloaden",
      view_details: "Details Bekijken"
    },
    footer: {
      rights: "Alle rechten voorbehouden",
      privacy: "Privacybeleid",
      terms: "Servicevoorwaarden",
      tagline: "Exclusieve ledenkortingen langs de Costa del Sol",
      for_members: "Voor Leden",
      directory: "Gids",
      for_business: "Voor Bedrijven",
      become_partner: "Word Partner",
      qr_scanner: "QR Scanner",
      affiliates: "Affiliates",
      become_affiliate: "Word Affiliate",
      earn_commission: "Verdien 20% commissie"
    }
  }
};

export default translations;
